exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "request-form-sick-leave-reports .request-form-sick-leave-reports-container.responsiveMobile .icon{display:inline-block;margin-right:10px}request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-row{margin-bottom:24px}request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-add{font-size:15px;color:#0072c9;margin-top:27px;display:inline-block;margin-bottom:14px}request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-add:focus,request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-add:hover{color:#0072c9;background:#fff;text-decoration:none}request-form-sick-leave-reports .request-form-sick-leave-reports-container .sick-leave-report-add .glyphicon{display:inline-block;margin-right:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormSickLeaveReports/requestFormSickLeaveReports.scss
// module id = 1402
// module chunks = 0